import script from "./CommentsOverviewDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./CommentsOverviewDialog.vue?vue&type=script&setup=true&lang=js"

import "./CommentsOverviewDialog.vue?vue&type=style&index=0&id=340d86cc&lang=css"
import "./CommentsOverviewDialog.vue?vue&type=style&index=1&id=340d86cc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-340d86cc"]])

export default __exports__